import { z } from 'zod'

export const AccessProviderSchema = z.enum(['vercel', 'netlify', 'cloudflare', 'turnstile', 'recaptcha', 'hcaptcha', 'otp', 'unknown'])
export type AccessProvider = z.infer<typeof AccessProviderSchema>
export const VerificationChannelSchema = z.enum(['email', 'sms', 'totp', 'unknown'])
export type VerificationChannel = z.infer<typeof VerificationChannelSchema>
export const PhoneNumberSchema = z.string().trim().max(32).regex(/^\+?[0-9][0-9 ()-]+$/)
  .refine(value => { const digits = value.replace(/\D/g, ''); return digits.length >= 7 && digits.length <= 15 }, 'Enter a complete phone number')
export const AccessBlockerSchema = z.object({
  provider: AccessProviderSchema,
  url: z.string().url().max(4000).refine(value => /^https?:\/\//i.test(value), 'A web URL is required'),
  detail: z.string().trim().min(1).max(2000),
  verification_channel: VerificationChannelSchema.optional(),
  input_kind: z.enum(['code', 'phone']).optional(),
})
export type AccessBlocker = z.infer<typeof AccessBlockerSchema>
export const AccessRequestSchema = AccessBlockerSchema.extend({
  id: z.string(),
  task_id: z.string(),
  expires_at: z.string(),
})
export type AccessRequest = z.infer<typeof AccessRequestSchema>
export const ProjectAccessSchema = z.object({
  vercel_configured: z.boolean(),
  requests: z.array(AccessRequestSchema),
})
export type ProjectAccess = z.infer<typeof ProjectAccessSchema>
const SecretSchema = z.string().trim().min(1).max(1024).regex(/^[^\s]+$/, 'Enter the bypass secret without whitespace')
export const ProjectAccessMutationSchema = z.discriminatedUnion('action', [
  z.object({ action: z.literal('save-vercel'), project_id: z.string().min(1), secret: SecretSchema.nullable() }).strict(),
  z.object({ action: z.literal('answer'), project_id: z.string().min(1), request_id: z.string().min(1), value: z.string().trim().max(1024) }).strict(),
])
export const TaskAccessMutationSchema = z.discriminatedUnion('action', [
  AccessBlockerSchema.extend({ action: z.literal('request'), wait_seconds: z.number().int().min(1).max(600).default(600) }).strict(),
  z.object({ action: z.literal('poll'), request_id: z.string().min(1) }).strict(),
  z.object({ action: z.literal('expire'), request_id: z.string().min(1) }).strict(),
])
export const TaskDeploymentAccessSchema = z.object({ vercel_bypass_secret: z.string().nullable() })
export const AccessPollSchema = z.object({ resolved: z.boolean(), value: z.string().nullable(), expired: z.boolean() })
export const AccessRequestResponseSchema = z.object({ request: AccessRequestSchema })
export const AccessSuccessSchema = z.object({ ok: z.literal(true) })
